import { UIText2 } from '@cian/ui-kit';
import { IconActionClose12 } from '@cian/ui-kit-design-tokens/icons';
import * as React from 'react';

import * as styles from './styles.css';

interface INewbuildingFlatTourBookingNotificationProps {
  onClose(): void;
  description: string;
}

export const NewbuildingFlatTourBookingNotification: React.FC<INewbuildingFlatTourBookingNotificationProps> = ({
  onClose,
  description,
}) => {
  return (
    <div className={styles['container']}>
      <div className={styles['notification']}>
        <div className={styles['calendar']} />
        <UIText2 fontWeight="bold">{description}</UIText2>
        <button onClick={onClose} className={styles['close']}>
          <IconActionClose12 />
        </button>
      </div>
    </div>
  );
};
